import { IAppState } from '../../common/state';

export const getAggregatedOffers = (state: IAppState) => state.results.aggregatedOffers;
